import React from "react";

import ClientRefusalReasonCellContent from "../components/ClientRefusalReasonCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function clientRefusalReason({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.ClientRefusalReason,
		(item) => (
			<ClientRefusalReasonCellContent item={item} language={language} />
		),
		{
			width,
			sortable: false,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default clientRefusalReason;
